import { fetchReference } from '../../network/referenceRequests'

//creates a map from categoryId => {name, level, parent}
//categories are level 0, subcategories level 1, subsubcategories level 2
function createCategoryMap(categories){
	if(!categories) return []
	let map = {}
	Object.values(categories).forEach(category => {
		
		map[category.id] = { "category": category.category, "level": 0, id: category.id}
		if(category.children){
			Object.values(category.children).forEach(subcategory => {
				map[subcategory.id] = { "category": subcategory.category, "level": 1, "parent": category.id, id: subcategory.id }
				if(subcategory.children){
					Object.values(subcategory.children).forEach(subsubcategory => {
						map[subsubcategory.id] = {"category": subsubcategory.category, "level" : 2, "parent": subcategory.id, id: subsubcategory.id}
					})
				}
			})
		}
	})
	return map
}

// initial state
const state = {
	categories: null,
	preferenceOptions: null,
}

// getters
const getters = {
	categoriesMap:  (state) =>{
		return createCategoryMap(state.categories)
	}
}

// actions
const actions = {
	//fetch reference object from server
	getReference({ commit }) {
		let cached = sessionStorage.getItem("cherry_tree_reference")
		if(cached){
			commit("setCategories", JSON.parse(cached));
			return Promise.resolve()
		}

		return new Promise((resolve, reject) => {
			fetchReference(
				categories => {
					commit("setCategories", categories)
					sessionStorage.setItem("cherry_tree_reference", JSON.stringify(categories))
					resolve()
				},
				errorMessage => {
					reject(errorMessage)
				})
		})
	},
}

// mutations
const mutations = {
	setCategories(state, categories) {
		state.categories = categories
	},
	setPreferenceOptions(state, preferenceOptions) {
		state.preferenceOptions = preferenceOptions
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}